export const SOCIAL_WINDOW_DAYS = 15;

const KNOWN_ACCOUNTS = {
  elonmusk: {
    display_name: 'Elon Musk',
    avatar_url: 'https://pbs.twimg.com/profile_images/1683325380441128960/yRsRRjGO_400x400.jpg',
    profile_url: 'https://x.com/elonmusk',
  },
};

export function getSocialCutoff(now = new Date()) {
  const cutoff = new Date(now);
  cutoff.setUTCDate(cutoff.getUTCDate() - SOCIAL_WINDOW_DAYS);
  return cutoff.toISOString();
}

export function parseSocialImages(images) {
  if (!images) return [];
  if (Array.isArray(images)) return images.filter(Boolean);
  try {
    const parsed = JSON.parse(images);
    return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
  } catch {
    return [];
  }
}

export function inferUsername(sourceUrl) {
  if (!sourceUrl) return '';
  const match = String(sourceUrl).match(/^https?:\/\/(?:www\.)?(?:x|twitter)\.com\/([^/?#]+)/i);
  return match ? match[1].replace(/^@/, '').toLowerCase() : '';
}

export function normalizeSocialPost(post = {}) {
  const username = String(post.author_username || inferUsername(post.source_url)).replace(/^@/, '').toLowerCase();
  const known = KNOWN_ACCOUNTS[username] || {};

  return {
    ...post,
    author_username: username,
    author_name: post.author_name || known.display_name || username || 'Community',
    author_avatar: post.author_avatar || known.avatar_url || '',
    profile_url: post.profile_url || known.profile_url || (username ? `https://x.com/${username}` : ''),
    account_path: username ? `/social/${username}` : '/social',
    images: parseSocialImages(post.images),
    metrics: typeof post.metrics === 'object' && post.metrics ? post.metrics : {},
  };
}

export function groupPostsByAccount(posts = [], accountRows = []) {
  const accounts = new Map();

  accountRows.forEach((account) => {
    const username = String(account.username || '').replace(/^@/, '').toLowerCase();
    if (!username) return;
    accounts.set(username, {
      username,
      display_name: account.display_name || username,
      avatar_url: account.avatar_url || '',
      bio: account.bio || '',
      profile_url: account.profile_url || `https://x.com/${username}`,
      posts: [],
    });
  });

  posts.map(normalizeSocialPost).forEach((post) => {
    if (!post.author_username) return;
    if (!accounts.has(post.author_username)) {
      accounts.set(post.author_username, {
        username: post.author_username,
        display_name: post.author_name,
        avatar_url: post.author_avatar,
        bio: '',
        profile_url: post.profile_url,
        posts: [],
      });
    }
    accounts.get(post.author_username).posts.push(post);
  });

  return Array.from(accounts.values())
    .map((account) => {
      const sortedPosts = [...account.posts].sort((a, b) => new Date(b.posted_at || 0) - new Date(a.posted_at || 0));
      return {
        ...account,
        posts: sortedPosts,
        post_count: sortedPosts.length,
        latest_post: sortedPosts[0] || null,
      };
    })
    .filter((account) => account.post_count > 0)
    .sort((a, b) => new Date(b.latest_post?.posted_at || 0) - new Date(a.latest_post?.posted_at || 0));
}
